<template>
  <section class="project-page">
    <div class="container">
      <div class="row">
        <div class="col-12">
          <gf-custom-page-bar :header-data="headersList[0]" />
          <router-view />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import GfCustomPageBar from '@/shared-modules/shared-components/shared/GfCustomPageBar';
import ProjectCreateMessages from '../project.create.messages';

export default {
  // eslint-disable-next-line vue/match-component-file-name
  name: 'ForkLayout',
  components: { GfCustomPageBar },
  data() {
    return {
      headersList: [
        {
          name: 'createFork',
          text: this.$t('fork.create'),
          description: this.$t('fork.createDescription'),
          url: ''
        }
      ]
    };
  },
  mounted() {
    this.headersList[0].url = this.$route.path;
  },
  i18n: {
    messages: ProjectCreateMessages
  }
};
</script>
